import { Link } from "react-router";

import type { MyClaim } from "../../api/claims";
import { nl } from "../../i18n/nl";
import styles from "./claims.module.css";
import { useMyClaims } from "./queries";

const t = nl.claims;
const DAY = 86_400_000;

/** Countdown ring: the part of the claim period that is left. */
function Ring({ claim, now }: { claim: MyClaim; now: number }) {
  const start = new Date(claim.started_at).getTime();
  const end = new Date(claim.expires_at).getTime();
  const left = Math.max(0, Math.min(1, (end - now) / (end - start)));
  const radius = 8;
  const length = 2 * Math.PI * radius;
  return (
    <svg className={styles.ring} width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
      <circle className={styles.ringTrack} cx="11" cy="11" r={radius} fill="none" strokeWidth="3" />
      <circle
        className={styles.ringValue}
        cx="11"
        cy="11"
        r={radius}
        fill="none"
        strokeWidth="3"
        strokeLinecap="round"
        strokeDasharray={length}
        strokeDashoffset={length * (1 - left)}
        transform="rotate(-90 11 11)"
      />
    </svg>
  );
}

export function MyClaimsBlock({ headingClassName }: { headingClassName?: string }) {
  const claims = useMyClaims();
  if (!claims.data) return null;
  const { items, max } = claims.data;
  const now = Date.now();
  return (
    <section className={styles.block} aria-labelledby="my-claims-title">
      <h2 id="my-claims-title" className={headingClassName}>
        {t.sidebarTitle(items.length, max)}
      </h2>
      {items.length === 0 ? (
        <p className={styles.blockEmpty}>{t.none}</p>
      ) : (
        items.map((claim) => {
          const days = Math.max(0, Math.ceil((new Date(claim.expires_at).getTime() - now) / DAY));
          return (
            <Link key={claim.id} to={`/bedrijven/${claim.company_id}`} className={styles.claim}>
              <Ring claim={claim} now={now} />
              <span className={styles.claimText}>
                <span className={styles.claimName}>{claim.company_name}</span>
                <span className={styles.claimDays}>{t.daysLeft(days)}</span>
              </span>
            </Link>
          );
        })
      )}
    </section>
  );
}
